<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { fmtDate, withUnit } from './format';
  import { destinationUnit, journeyLabel, journeyMetricsOf } from './report';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  export let report: any;

  $: journeyMetrics = journeyMetricsOf(report);
</script>

  <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
    <h2 class="text-lg font-semibold mb-1">{$_('report.versions.heading')}</h2>
    <p class="text-sm text-zinc-500 mb-3">{$_('report.versions.intro')}{report.plan_updates?.length && report.forecast_history.versions.length === 1 ? $_('report.versions.as_updated') : ''}.</p>
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left text-zinc-500 align-bottom">
            <th class="font-normal py-1 pr-4 whitespace-nowrap">{$_('report.versions.version')}</th>
            <th class="font-normal py-1 pr-4 whitespace-nowrap">{$_('report.versions.saved')}</th>
            <th class="font-normal py-1 pr-6 whitespace-nowrap">{$_('report.versions.target_date')}</th>
            {#each journeyMetrics as m}<th class="font-normal py-1 pl-4 text-right whitespace-nowrap" title={journeyLabel(report, m)}>{m}</th>{/each}
          </tr>
        </thead>
        <tbody>
          {#each report.forecast_history.versions as v}
            <tr class="border-t">
              <td class="py-1.5 pr-4">{v.version_id}</td>
              <td class="py-1.5 pr-4 whitespace-nowrap">{new Date(v.saved_at).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}</td>
              <td class="py-1.5 pr-6 whitespace-nowrap">{fmtDate(v.target_date, 'short')}</td>
              {#each journeyMetrics as m}<td class="py-1.5 pl-4 text-right tabular-nums whitespace-nowrap">{withUnit(destinationUnit(m), v.destination[m])}</td>{/each}
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </section>
  <section class="mb-6 rounded border border-zinc-200 bg-white p-4">
    <h2 class="text-lg font-semibold mb-2">{$_('report.versions.changed')}</h2>
    {#if report.forecast_history?.revisions?.length}
      <ul class="text-sm text-zinc-700 space-y-1 list-disc pl-5">
        {#each report.forecast_history.revisions as rev}<li>{rev.text}</li>{/each}
      </ul>
    {:else}
      <p class="text-sm text-zinc-500">{report.plan_updates?.length ? $_('report.versions.no_other') : $_('report.versions.no_change')}</p>
    {/if}
    {#if report.plan_updates?.length}
      <p class="text-sm text-zinc-700 mt-3">{$_('report.versions.updated_from', { values: { dates: report.plan_updates.map((u) => fmtDate(u.date, 'short')).join(', ') } })}</p>
    {/if}
    <p class="text-xs text-zinc-500 mt-3">{$_('report.versions.keeps')}</p>
  </section>
